import HeroBasic from '../components/HeroBasic.js';
import Card from '../components/Card.js';
import InfoBox from '../components/InfoBox.js';
import Button from '../components/Button.js';

function BuildInfoBoxes() {
        var infoBoxData = [
                {
                        title: "Search Portal",
                        body: "Search inspection reports and notices of violation.",
                        button: {
                                text: "Open Portal",
                                href: "/portal"
                        }
                },
                {
                        title: "Why This Matters",
                        body: "Learn why environmental transparency and enforcement oversight matter.",
                        button: {
                                text: "Read More",
                                href: "/why-this-matters"
                        }
                },
                {
                        title: "Project Background",
                        body: "Learn how the FOIA effort and data collaboration developed.",
                        button: {
                                text: "Project History",
                                href: "/project-background"
                        }
                }
        ]

        var infoBoxes = infoBoxData.map((a, index) => 
                <InfoBox key={index} header={a.title}>
                        <p>{a.body}</p>
                        <Button href={a.button.href}>
                                {a.button.text}
                        </Button>
                </InfoBox>        
        )

        return <div className='grid'>{infoBoxes}</div>
}

function Home() {
        var heroTitle = "Eyes on Environmental Enforcement Project";
        var heroSubtitle = "A public-interest transparency initiative exposing environmental enforcement records obtained through FOIA."

        var cardHeader = "About the Project"
        var infoBoxes = BuildInfoBoxes()

        return (
                <div className="Home">
                        <HeroBasic title={heroTitle} subtitle={heroSubtitle}/>
                        <Card header={cardHeader}>
                                <p>Eyes on Environmental Enforcement provides online access to Environmental Protection Agency (EPA) inspection reports and notices of violation issued under the Clean Air, Clean Water, and Resource Conservation and Recovery Acts. Public Employees for Environmental Responsibility (PEER) obtained the records through a Freedom of Information Act request. It added information from EPA’s ECHO tracking system and an EPA Region 6 online repository.</p>
                                <p>Users can search by document type, year, EPA region, company or facility name, and, in most cases, state. Records cover 2021 through some or all of 2025, plus a few from 2026. These records may identify specific violations and sometimes include sampling or monitoring results. Communities can use them to challenge permits for violators and support citizen suits. Reporters, researchers, and the public can access documents on potential violations and illegal emissions.</p>
                                <p>PEER is partnering with the Environmental Data & Governance Initiative (<a href="https://envirodatagov.org/">EDGI</a>) on this project. Posting searchable documents is the first step. We will add documents, analysis, and features to this site in the future.</p>
                                {infoBoxes}
                        </Card>
                </div>
        );
}

export default Home;
